import { PLAY_STORE_URL } from '../config/storeLinks';

type PlayStoreButtonProps = {
  className?: string;
  compact?: boolean;
};

export function PlayStoreButton({ className = '', compact = false }: PlayStoreButtonProps) {
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 sm:gap-3 bg-[#111818] text-white rounded-full font-semibold hover:bg-black transform hover:-translate-y-0.5 transition-all shadow-md active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 motion-reduce:transition-none motion-reduce:transform-none ${
        compact
          ? 'min-h-[2.5rem] px-4 py-2 text-xs sm:text-sm'
          : 'min-h-[3.25rem] sm:min-h-[3.5rem] px-6 py-3.5 text-sm sm:text-base'
      } ${className}`}
    >
      <svg
        className={`shrink-0 ${compact ? 'size-4' : 'size-5'}`}
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          fill="#4285F4"
          d="M3.45.195a1.466 1.466 0 0 0-.946-.179L13.544 10.99l3.258-3.238L3.45.195z"
        />
        <path
          fill="#34A853"
          d="M13.544 13.057 2.504 23.99c.298.036.612-.016.906-.183l13.324-7.55-3.19-3.2z"
        />
        <path
          fill="#FBBC04"
          d="m22.018 13.298-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594z"
        />
        <path
          fill="#EA4335"
          d="M1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924z"
        />
      </svg>
      {compact ? 'Google Play' : 'Get it on Google Play'}
    </a>
  );
}
